angular.module('SpidApp')

.controller('InventoryDetailController', 
		['BASE_PUBLIC_URL', '$scope', '$stateParams', '$filter', '_', 'InventoryService', 'UserService', 'ProductService', 'OperationalProductService', 'StockManager', 'Toaster', '$timeout', '$uibModal',     
function (BASE_PUBLIC_URL,   $scope,   $stateParams,   $filter,   _,   InventoryService,   UserService,   ProductService,   OperationalProductService,   StockManager,   Toaster,   $timeout,   $uibModal) {
		
	if (!$stateParams.agencyId) {
        throw 'InventoryDetailController() - You should provide an agency id'
    }
	if (!$stateParams.inventoryId) {
        throw 'InventoryDetailController() - You should provide an inventory id'
    }
    
    var agencyId 	= $stateParams.agencyId
    var inventoryId = $stateParams.inventoryId
    
    $scope.filter = {};
    $scope.sort = 'inventory.updated_at';
    $scope.asc = true;
    
    
    var fetchInventory = function() {
    	UserService.all().then(function(users) {
    		$scope.users = users;
    		InventoryService.findByAgencyIdAndInventoryId(agencyId, inventoryId).then(function(inventory) {
    			$scope.inventory = inventory;
    			
    			$scope.inventory.globalStock=0;
    			$scope.inventory.ecartGlobalStock=0;
    			
	    		var user = _.find(users, function(user) {
	    	    	return user.id === $scope.inventory.user_id;
    	    	});
	    		
	    		if (user) {
	    			$scope.inventory.userFirstname = user.firstname;
	    			$scope.inventory.userLastname = user.lastname;
	    		}
	    		
	    		try {
	    			$scope.inventoryProducts = JSON.parse($scope.inventory.products)
	    			
	    		}
	    		catch (err) {
	    			console.error("InventoryDetailController() - Error when parse the JSON")
	    		}
	    		if ($scope.inventory.type ==='PRO') {
	    			$scope.inventoryProducts = _.map($scope.inventoryProducts, function(inventoryProduct) {
	    				inventoryProduct.stockDiff = (inventoryProduct.quantity - (inventoryProduct.qtyOrigine || 0));
	    				inventoryProduct.valEuro = (inventoryProduct.quantity * inventoryProduct.product.price).toFixed(2);
	    				inventoryProduct.ecartEuro = ((inventoryProduct.quantity - inventoryProduct.qtyOrigine ) * inventoryProduct.product.price).toFixed(2);  
	    				
	    				$scope.inventory.globalStock += parseFloat(inventoryProduct.valEuro);
	    				$scope.inventory.ecartGlobalStock += parseFloat(inventoryProduct.ecartEuro) ;
	    				
	    				return inventoryProduct;
	    			});	    			
	    		}
    	    })
    	});
    }
    fetchInventory();
    
    $scope.saveStockProduct = function() {
    	var modal = $uibModal.open({
			animation: $scope.animationsEnabled,
			templateUrl: BASE_PUBLIC_URL + '/views/partials/inventory-request.html',
			controller: 'InventoryDetailModalController',
			size: 'sm',
			scope: $scope,
			resolve: {
				inventory: function () {
					return $scope.inventory
				}
			}
		})

        modal.result.then(function () {
          StockManager.saveStockProducts($scope.inventoryProducts, agencyId).then(function() {
            Toaster.show('Les nouvelles valeurs de stock ont été sauvegardées')
          });
        });
    }
    
    $scope.printInventoryDetail = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
    	$timeout(function() {
    		window.print();
    	}, 50);
	}
    
}])

.controller('InventoryDetailModalController', function ($scope, $uibModalInstance, inventory) {

  $scope.inventory = inventory;

  $scope.ok = function () {
    $uibModalInstance.close();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
})
